import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2.ts';
import {
    PERSONALIZED_CATALOGS_V3,
    PDP_SPONSORED_MORE_SIMILAR_ITEMS_GRID,
    PDP_SPONSORED_INFINITE_GRID_MW,
    SOLD_PDP_SPONSORED_YMAL_GRID,
} from '../constants/abTestsConstants.ts';

export const ITEM_PRICE_IN_SELLABILITY = 'ItemPriceInSellability' as const;
export const TRADE_QUICK_FILTERS = 'TradeQuickFilters' as const;
export const URGENCY_SIGNALS_MW = 'CartUrgencySignalMWv2' as const;
export const TABLE_SIZE_FILTER = 'TableSizeFilter' as const;
export const SHIPPING_COST_SB = 'ShippingCostSB' as const;
export const CONTENT_VISIBILITY_SB = 'ContentVisibilitySB' as const;
export const SHIPS_FROM_SB_TILE = 'ShipsFromSBTile' as const;
export const QUICK_FILTERS_REDESIGN = 'quick_filters_redesign' as const;
export const DRIVE_SAVED_SEARCH_ADOPTION = 'driveSavedSearchAdoption_Aug2026' as const;
export const REMOVE_COUNTS = 'remove_counts' as const;
export const VECTOR_SEARCH_FALLBACK = 'vector_search_fallback' as const;
export const OPEN_PDP_IN_NEW_TAB = 'open_pdp_in_new_tab' as const;
const RANGE_FILTERS_DESKTOP_UI = 'range_filters_desktop_ui' as const;

export const getShippingCostSbVariant = (): string | undefined =>
    getAbTestV2(SHIPPING_COST_SB)?.variant;

export const getIsShipsFromSBTileVariant = (getAbTestFunc = getAbTestV2): boolean =>
    getAbTestFunc(SHIPS_FROM_SB_TILE)?.variant === 'variant';

export const getIsPersonalizedCatalogsV3Variant = (): boolean =>
    getAbTestV2(PERSONALIZED_CATALOGS_V3)?.variant === 'variant';

export const getPdpSponsoredMoreSimilarItemsGridTest = (): string | undefined =>
    getAbTestV2(PDP_SPONSORED_MORE_SIMILAR_ITEMS_GRID)?.variant;

export const trackPdpSponsoredMoreSimilarItemsGridTest = (): void => {
    trackAbTestV2Variant(PDP_SPONSORED_MORE_SIMILAR_ITEMS_GRID);
};

export const getPdpSponsoredInfiniteGridMwTest = (): string | undefined =>
    getAbTestV2(PDP_SPONSORED_INFINITE_GRID_MW)?.variant;

export const trackPdpSponsoredInfiniteGridMwTest = (): void => {
    trackAbTestV2Variant(PDP_SPONSORED_INFINITE_GRID_MW);
};

export const trackQuickFiltersRedesignTest = (): void => {
    trackAbTestV2Variant(QUICK_FILTERS_REDESIGN);
};

export const trackDriveSavedSearchAdoptionTest = (): void => {
    trackAbTestV2Variant(DRIVE_SAVED_SEARCH_ADOPTION);
};

export const trackRangeFiltersDesktopUi = (): void => {
    trackAbTestV2Variant(RANGE_FILTERS_DESKTOP_UI);
};

export const getIsOpenPdpInNewTabVariant = (): boolean =>
    getAbTestV2(OPEN_PDP_IN_NEW_TAB)?.variant === 'variant';

export const getIsRangeFiltersUiVariant = (): boolean =>
    getAbTestV2(RANGE_FILTERS_DESKTOP_UI)?.variant === 'variant';

export const trackSoldPdpSponsoredYmalGridTest = (): void => {
    trackAbTestV2Variant(SOLD_PDP_SPONSORED_YMAL_GRID);
};

export const getSoldPdpSponsoredYmalGridTest = (): string | undefined =>
    getAbTestV2(SOLD_PDP_SPONSORED_YMAL_GRID)?.variant;
